import { withStyles } from '../../tools/withStyles';
import { Component } from './Template';
import { styles } from './Template.styles';

const Template = withStyles(styles)(Component);

export default Template;
